<div class="product-list">
  <div class="row product-row" *ngIf="products && products.length">
    <div
      class="col-12 col-sm-6 col-lg-4 col-xl-4 col-xxl-3 mb-5"
      *ngFor="let p of products"
    >
      <vw-product-card [product]="p"></vw-product-card>
    </div>
  </div>

  <vw-alert
    *ngIf="error"
    type="danger"
    [message]="'errorMessages.default' | translate"
  >
  </vw-alert>

  <vw-alert
    *ngIf="
      noProductsMessage &&
      !error &&
      !searchLoading &&
      !productsLoading &&
      !products.length
    "
    type="info"
    [message]="noProductsMessage"
  >
  </vw-alert>

  <div class="d-flex justify-content-center mb-4">
    <vw-button
      (click)="getProducts()"
      *ngIf="!searchLoading && !productsLoading && !error && showLoadMore"
      [primary]="true"
      [text]="'loadMore' | translate"
    >
    </vw-button>

    <vw-loading *ngIf="searchLoading || productsLoading"></vw-loading>
  </div>

  <div *ngIf="categories.length" class="row pt-3 mt-5 border-top">
    <div class="col-12">
      <p>{{ "searchPage.categories" | translate }}</p>
    </div>

    <div class="col-12 d-flex flex-wrap">
      <div *ngFor="let result of categories" class="mb-3 me-3">
        <vw-link
          [text]="result.displayName"
          [icon]="'fal fa-long-arrow-right'"
          [routerLinks]="[
            '/' + themeService.brand,
            'category',
            result.catalogCategoryId,
            result.displayName || '' | encodeURIComponent,
          ]"
        ></vw-link>
      </div>
    </div>
  </div>
</div>
